export default "__VITE_ASSET__ac421b7a__"